export default {
    workLoadBalanceSubperiod: { method: 'get', url: 'control_panel/work_load_balance_subperiod'},
}
